
    import React, { useEffect, useState } from "react";
    import "./index.scss";
    import { Row, Col, Card } from "react-bootstrap";
    import { useSelector,useDispatch } from "react-redux";
    import { getOrgInfo } from "api/organisation";
    import { Image } from "react-bootstrap";


    
    const SuccessPopUp = (props) => {
      const [companyName, getCompanyName] = useState('');
      const organisation_id = useSelector(
        (state) => state?.loggedInUserInfo
      ).organisation_id;
      let [logoUrl, setLogoURL] = useState();

      useEffect(()=>{
          getOrgInfo({ _id: organisation_id }).then((res) => {
            if (res?.logo) {
              setLogoURL('https://signdesk.in/company/' + res?.logo)
              const list = document.getElementById('favicon_customized');
              // list.href = '/unified/' + (res?.fav_icon ? res?.fav_icon : 'signdesk_logo@2x.png');
              list.href = res?.icon ? `https://signdesk.in/company/${res?.icon}` : 'https://signdesk.com/images/favicon.png';
              const titleName = document.getElementById('title-id');
              titleName.innerText = res?.setting?.parent_client_name || "loading...";
              getCompanyName(res?.setting?.parent_client_name)
            } else {
              setLogoURL("https://signdesk.in/company/signDesk-logo.png")
              const list = document.getElementById('favicon_customized');
              list.href = '/unified/signdesk_logo@2x.png';
              const titleName = document.getElementById('title-id');
              titleName.innerText = 'Signdesk';
              getCompanyName('Signdesk')
            }
          })
      },[organisation_id])

      const {  onSubmit, header,content ,userName} = props;
 
      return (
       companyName &&  
       <Col xxl={6} lg={7} md={10} xs={12}>
        <div className="bg-white p-2 p-md-4 rounded-3">
          <div className="p-3 mb-3 bg-forms-two bg-cover br-top-left-15px br-top-right-15px">
            <p className="fs-20px m-0 text-theme fw-bold text-center">{header}</p>
          </div>
        {userName ?  
        <p className="m-0 fw-bold fs-18px">
           Hey ${userName},
        </p> : ''}
        <p className="my-0 my-lg-5 fs-16px py-4 text-center">
        {content}
        </p>
        <p className="m-0 text-center fs-13px pt-2 pt-md-4 text-muted border-top">{companyName}. All rights reserved.</p>
        </div>
       </Col>
      );
    };

 

export default SuccessPopUp